import React from 'react';
import {View, Text} from 'react-native';

import { StyleSheet } from 'react-native';

interface TableBodyCellProps {
  flex?: number;
  width?: number | string;
  children: React.ReactNode;
  justify?: 'flex-start' | 'center' | 'flex-end';
}

const TableBodyCell = (props: TableBodyCellProps) => {

  const {flex = 1, width, justify = 'flex-start'} = props;

  return (
    <>
      <View
        style={[
          styles.rootContainer,
          props.width ? {width: width} : {flex: flex},
          {
            justifyContent: justify,
          },
        ]}>
        {props.children}
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  rootContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%',
    paddingHorizontal: 12,
  },
});

export default TableBodyCell;
